// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zbav","top":"styles_top__3LaMO"};